/// <amd-module name="RMWidgets/ReleasePipelineWidget/ReleasePipelineStatusDataProvider" />
import { IVssPageContext } from "VSS/Platform/Context";

import * as TfsWidgetContext from "Tfs/Widget/Context";

import {
    Release,
    ReleaseDefinition,
    ReleaseExpands,
    PropertySelector,
    PropertySelectorType
} from "Release/Client/Contracts/Release";
import { IReleaseRestClient } from "Release/Client/RestClient/Release";

export interface IReleasePipelineStatusData {
    releaseDefinition: ReleaseDefinition;
    releases: Release[];
}

/** Provides async method(s) to retrieve release pipeline status data from server */
export class ReleasePipelineStatusDataProvider {
    private static allEnvironmentsDefinitionId: number = 0;

    constructor(private pageContext: IVssPageContext) { }

    public async getReleasePipelineStatusData(releaseDefinitionId: number): Promise<IReleasePipelineStatusData> {
        const project = TfsWidgetContext.getProject(this.pageContext);
        const releaseRestClient = this.pageContext.getRestClient<IReleaseRestClient>("IReleaseRestClient");

        const releaseDefinition = await releaseRestClient.getReleaseDefinition(project.id, releaseDefinitionId);
        const propertySelector: PropertySelector = this.getPropertySelectorsForWidgetList();
        const releases = await releaseRestClient.getReleases(
            project.id,
            releaseDefinitionId,
            ReleasePipelineStatusDataProvider.allEnvironmentsDefinitionId,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            ReleaseExpands.Environments | ReleaseExpands.Approvals | ReleaseExpands.ManualInterventions | ReleaseExpands.Artifacts,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            propertySelector.properties
        );

        return {
            releaseDefinition: releaseDefinition,
            releases: releases
        };
    }

    private getPropertySelectorsForWidgetList(): PropertySelector {
        var propsToSelect: string[] = ["Name", "Id", "Description", "Artifacts"];
        var envProps: string[] = ["Name", "ScheduledDeploymentTime", "Status", "DeploySteps"];
        var approvalProps: string[] = ["ApprovalType", "Attempt", "Id", "IsAutomated", "Status"];

        Array.prototype.push.apply(envProps, approvalProps.map((prop: string) => { return "PreDeployApprovals." + prop }));
        Array.prototype.push.apply(envProps, approvalProps.map((prop: string) => { return "PostDeployApprovals." + prop }));
        Array.prototype.push.apply(propsToSelect, envProps.map((prop: string) => { return "Environments." + prop }));

        return {
            selectorType: PropertySelectorType.Inclusion,
            properties: propsToSelect
        };
    }
}
